export const CURATION_RULE: ValidationRule = {
  id: 'jps-curation',
  strict: true,
  fields: {
    id: {
      field: 'id',
      type: 'string',
      mandatory: false
    },
    curationType: {
      field: 'curationType',
      type: 'string',
      mandatory: true,
      enumKey: 'jps-curation_type',
      label: {
        ja: '種別',
        en: 'Type'
      }
    },
    title: {
      field: 'title',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-lang_string_yomi',
      label: {
        ja: 'タイトル',
        en: 'Title'
      }
    },
    summary: {
      field: 'summary',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-lang_string',
      label: {
        ja: '1行概要',
        en: 'Overview'
      }
    },
    rights: {
      field: 'rights',
      type: 'object',
      mandatory: false,
      allowHTML: [
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'a',
        'div',
        'p',
        'i',
        'b',
        'em',
        'blockquote',
        'strong',
        'br',
        'ul',
        'ol',
        'li'
      ],
      objRuleName: 'jps-lang_string',
      label: {
        ja: '二次利用条件表示(HTML可)',
        en: 'Rights(HTML Allowed)'
      }
    },
    rightsType: {
      field: 'rightsType',
      type: 'string',
      mandatory: false,
      codeKey: 'jps-rights_type',
      label: {
        ja: '権利区分',
        en: 'Rights Type'
      }
    },
    tag: {
      field: 'tag',
      type: 'array',
      mandatory: false,
      objRuleName: 'jps-tag_field',
      arraySubType: 'object',
      label: {
        ja: 'タグ',
        en: 'Tag'
      }
    },
    responsibility: {
      field: 'responsibility',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-lang_string',
      label: {
        ja: '責任表示',
        en: 'Responsibility'
      }
    },
    image: {
      field: 'image',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-image_selection',
      label: {
        ja: '代表画像',
        en: 'Representative Image'
      },
      imageSize: '1920x1080px',
      thumbSize: '640x360px',
      imageRatio: '16:9'
    },
    subPages: {
      field: 'subPages',
      type: 'array',
      mandatory: false,
      arraySubType: 'string',
      label: {
        ja: 'サブページID',
        en: 'Subpages'
      }
    },
    theme: {
      field: 'theme',
      type: 'string',
      mandatory: false,
      label: {
        ja: 'ギャラリーテーマ',
        en: ''
      }
    },
    workspace: {
      field: 'workspace',
      type: 'string',
      mandatory: false
    },
    workspaceTags: {
      field: 'workspaceTags',
      type: 'array',
      mandatory: false,
      arraySubType: 'string',
      label: {
        ja: 'ワークスペースタグ',
        en: 'Workspace Tag'
      }
    }
  }
  , enums: {
    'jps-curation_type': CURATION_TYPE_DEF
  }
}
export const CURATION_PART_DEFINITION_RULE: ValidationRule = {
  id: 'jps-curation_part_definition',
  strict: true,
  fields: {
    cpid: {
      field: 'cpid',
      type: 'string',
      mandatory: false
    }
  }
}
export const PART_AREA_ANNOTATION_RULE: ValidationRule = {
  id: 'jps-part_area_annotation',
  strict: true,
  fields: {
    rect: {
      field: 'rect',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-rect',
      label: {
        ja: '領域',
        en: 'Area'
      }
    },
    title: {
      field: 'title',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-lang_string',
      label: {
        ja: 'タイトル',
        en: 'Title'
      }
    },
    description: {
      field: 'description',
      type: 'object',
      mandatory: false,
      allowMultiline: true,
      objRuleName: 'jps-lang_string',
      label: {
        ja: '説明',
        en: 'Description'
      }
    }
  }
}
export const PART_IFRAME_RULE: ValidationRule = {
  id: 'jps-part_iframe',
  strict: false,
  fields: {
    iframeSrc: {
      field: 'iframeSrc',
      type: 'string',
      mandatory: true,
      allowMultiline: true,
      allowHTML: [
        'iframe'
      ],
      label: {
        ja: 'iframeのスニペット',
        en: 'Iframe snippet'
      }
    },
    caption: {
      field: 'caption',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-lang_string',
      label: {
        ja: 'キャプション',
        en: 'Caption'
      }
    },
    description: {
      field: 'description',
      type: 'object',
      mandatory: false,
      allowMultiline: true,
      objRuleName: 'jps-lang_string',
      label: {
        ja: '説明',
        en: 'Description'
      }
    },
    layout: {
      field: 'layout',
      type: 'string',
      mandatory: false,
      enumKey: 'jps-iframe_layout',
      label: {
        ja: 'レイアウト',
        en: 'Image Layout'
      }
    }
  }
  , enums: {
    'jps-iframe_layout': IFRAME_LAYOUT_DEF
  }
}
export const PART_IMAGE_RULE: ValidationRule = {
  id: 'jps-part_image',
  strict: false,
  fields: {
    image: {
      field: 'image',
      type: 'object',
      mandatory: true,
      objRuleName: 'jps-image_selection'
    },
    imageEn: {
      field: 'imageEn',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-image_selection'
    },
    height: {
      field: 'height',
      type: 'string',
      mandatory: false,
      label: {
        ja: '画像の高さ',
        en: 'Image Height'
      }
    },
    caption: {
      field: 'caption',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-lang_string',
      label: {
        ja: 'キャプション',
        en: 'Caption'
      }
    },
    description: {
      field: 'description',
      type: 'object',
      mandatory: false,
      allowMultiline: true,
      objRuleName: 'jps-lang_string',
      label: {
        ja: '説明',
        en: 'Description'
      }
    },
    background: {
      field: 'background',
      type: 'string',
      mandatory: false,
      enumKey: 'jps-image_background',
      label: {
        ja: '背景画像',
        en: 'Image Background'
      }
    },
    layout: {
      field: 'layout',
      type: 'string',
      mandatory: false,
      enumKey: 'jps-image_layout',
      label: {
        ja: 'レイアウト',
        en: 'Image Layout'
      }
    }
  }
  , enums: {
    'jps-image_background': IMAGE_BACKGROUND_DEF,
    'jps-image_layout': IMAGE_LAYOUT_DEF
  }
}
export const PART_IMAGE_ANNOTATION_RULE: ValidationRule = {
  id: 'jps-part_image_annotation',
  strict: false,
  fields: {
    image: {
      field: 'image',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-image_selection',
      label: {
        ja: '画像',
        en: 'Image'
      }
    }
  }
}
export const PART_INDEX_RULE: ValidationRule = {
  id: 'jps-part_index',
  strict: false,
  fields: {
    style: {
      field: 'style',
      type: 'string',
      mandatory: false,
      enumKey: 'jps-index_style'
    }
  }
  , enums: {
    'jps-index_style': INDEX_STYLE_DEF
  }
}
export const PART_LIST_RULE: ValidationRule = {
  id: 'jps-part_list',
  strict: false,
  fields: {
    title: {
      field: 'title',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-lang_string',
      label: {
        ja: 'リストタイトル',
        en: 'List Title'
      }
    },
    viewType: {
      field: 'viewType',
      type: 'string',
      mandatory: true,
      enumKey: 'jps-list_view_type',
      label: {
        ja: '表示スタイル',
        en: 'Layout'
      }
    },
    csId: {
      field: 'csId',
      type: 'string',
      mandatory: false,
      label: {
        ja: '表示用検索定義',
        en: 'Custom Search for columns'
      }
    },
    columns: {
      field: 'columns',
      type: 'array',
      mandatory: false,
      objRuleName: 'jps-custom_search_column',
      arraySubType: 'object',
      label: {
        ja: '表示項目',
        en: 'Display Columns'
      }
    },
    mapParam: {
      field: 'mapParam',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-map_param',
      label: {
        ja: '地図表示設定',
        en: 'Map Config'
      }
    },
    openActionType: {
      field: 'openActionType',
      type: 'string',
      mandatory: false,
      enumKey: 'jps-open_action_type'
    }
  }
  , enums: {
    'jps-list_view_type': LIST_VIEW_TYPE_DEF,
    'jps-open_action_type': OPEN_ACTION_TYPE_DEF
  }
}
export const PART_LIST_CURATION_RULE: ValidationRule = {
  id: 'jps-part_list_curation',
  strict: false,
  fields: {
    id: {
      field: 'id',
      type: 'string',
      mandatory: true
    },
    description: {
      field: 'description',
      type: 'object',
      mandatory: false,
      allowMultiline: true,
      objRuleName: 'jps-lang_string',
      label: {
        ja: '説明',
        en: 'Description'
      }
    },
    note: {
      field: 'note',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-lang_delta',
      label: {
        ja: '注記',
        en: 'Note'
      }
    },
    latlon: {
      field: 'latlon',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-lat_lon',
      label: {
        ja: '座標',
        en: 'Coordinates'
      }
    },
    image: {
      field: 'image',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-image_selection',
      label: {
        ja: '代表画像',
        en: 'Representative Image'
      }
    }
  }
}
export const PART_LIST_CUSTOM_SEARCH_RULE: ValidationRule = {
  id: 'jps-part_list_custom_search',
  strict: false,
  fields: {
    id: {
      field: 'id',
      type: 'string',
      mandatory: true
    },
    description: {
      field: 'description',
      type: 'object',
      mandatory: false,
      allowMultiline: true,
      objRuleName: 'jps-lang_string',
      label: {
        ja: '説明',
        en: 'Description'
      }
    },
    note: {
      field: 'note',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-lang_delta',
      label: {
        ja: '注記',
        en: 'Note'
      }
    },
    image: {
      field: 'image',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-image_selection',
      label: {
        ja: '代表画像',
        en: 'Representative Image'
      }
    }
  }
}
export const PART_LIST_DATABASE_RULE: ValidationRule = {
  id: 'jps-part_list_database',
  strict: false,
  fields: {
    id: {
      field: 'id',
      type: 'string',
      mandatory: true
    },
    description: {
      field: 'description',
      type: 'object',
      mandatory: false,
      allowMultiline: true,
      objRuleName: 'jps-lang_string',
      label: {
        ja: '説明',
        en: 'Description'
      }
    },
    note: {
      field: 'note',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-lang_delta',
      label: {
        ja: '注記',
        en: 'Note'
      }
    },
    image: {
      field: 'image',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-image_selection',
      label: {
        ja: '代表画像',
        en: 'Representative Image'
      }
    }
  }
}
export const PART_LIST_EXTERNAL_LINK_RULE: ValidationRule = {
  id: 'jps-part_list_external_link',
  strict: false,
  fields: {
    title: {
      field: 'title',
      type: 'object',
      mandatory: false,
      jaMandatory: true,
      objRuleName: 'jps-lang_string',
      label: {
        ja: 'リンクタイトル',
        en: 'Link Title'
      }
    },
    url: {
      field: 'url',
      type: 'string',
      mandatory: false,
      label: {
        ja: 'リンクURL',
        en: 'Link URL'
      }
    },
    source: {
      field: 'source',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-lang_string',
      label: {
        ja: '出典',
        en: 'Source'
      }
    },
    description: {
      field: 'description',
      type: 'object',
      mandatory: false,
      allowMultiline: true,
      objRuleName: 'jps-lang_string',
      label: {
        ja: '説明',
        en: 'Description'
      }
    },
    note: {
      field: 'note',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-lang_delta',
      label: {
        ja: '注記',
        en: 'Note'
      }
    },
    image: {
      field: 'image',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-image_selection',
      label: {
        ja: '画像',
        en: 'Representative Image'
      }
    },
    latlon: {
      field: 'latlon',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-lat_lon',
      label: {
        ja: '座標',
        en: 'Coordinates'
      }
    }
  }
}
export const PART_LIST_ITEM_RULE: ValidationRule = {
  id: 'jps-part_list_item',
  strict: false,
  fields: {
    id: {
      field: 'id',
      type: 'string',
      mandatory: true
    },
    title: {
      field: 'title',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-lang_string',
      label: {
        ja: 'タイトル（上書き）',
        en: 'Title(Overwrite)'
      }
    },
    description: {
      field: 'description',
      type: 'object',
      mandatory: false,
      allowMultiline: true,
      objRuleName: 'jps-lang_string',
      label: {
        ja: '説明（上書き）',
        en: 'Description(Overwrite)'
      }
    },
    note: {
      field: 'note',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-lang_delta',
      label: {
        ja: '注記',
        en: 'Note'
      }
    },
    linkUrl: {
      field: 'linkUrl',
      type: 'string',
      mandatory: false,
      label: {
        ja: 'リンクURL',
        en: 'リンクURL'
      }
    },
    image: {
      field: 'image',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-image_selection',
      label: {
        ja: '代表画像',
        en: 'Representative Image'
      }
    },
    latlon: {
      field: 'latlon',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-lat_lon',
      label: {
        ja: '座標',
        en: 'Coordinates'
      }
    }
  }
}
export const PART_LIST_ORGANIZATION_RULE: ValidationRule = {
  id: 'jps-part_list_organization',
  strict: false,
  fields: {
    id: {
      field: 'id',
      type: 'string',
      mandatory: true
    },
    description: {
      field: 'description',
      type: 'object',
      mandatory: false,
      allowMultiline: true,
      objRuleName: 'jps-lang_string',
      label: {
        ja: '説明',
        en: 'Description'
      }
    },
    note: {
      field: 'note',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-lang_delta',
      label: {
        ja: '注記',
        en: 'Note'
      }
    },
    image: {
      field: 'image',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-image_selection',
      label: {
        ja: '代表画像',
        en: 'Representative Image'
      }
    },
    latlon: {
      field: 'latlon',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-lat_lon',
      label: {
        ja: '座標',
        en: 'Coordinates'
      }
    }
  }
}
export const PART_LIST_SEARCH_RESULT_RULE: ValidationRule = {
  id: 'jps-part_list_search_result',
  strict: false,
  fields: {
    dataType: {
      field: 'dataType',
      type: 'string',
      mandatory: false,
      enumKey: 'jps-data_key'
    },
    title: {
      field: 'title',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-lang_string'
    },
    csId: {
      field: 'csId',
      type: 'string',
      mandatory: false
    }
  }
  , enums: {
    'jps-data_key': DATA_KEY_DEF
  }
}
export const PART_SEARCH_BOX_RULE: ValidationRule = {
  id: 'jps-part_search_box',
  strict: false,
  fields: {
    csId: {
      field: 'csId',
      type: 'string',
      mandatory: false
    },
    searchDef: {
      field: 'searchDef',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-custom_search_definition'
    },
    mode: {
      field: 'mode',
      type: 'string',
      mandatory: false,
      enumKey: 'jps-search_box_mode'
    },
    dataType: {
      field: 'dataType',
      type: 'string',
      mandatory: false,
      enumKey: 'jps-data_key'
    }
  }
  , enums: {
    'jps-search_box_mode': SEARCH_BOX_MODE_DEF,
    'jps-data_key': DATA_KEY_DEF
  }
}
export const PART_SECTION_RULE: ValidationRule = {
  id: 'jps-part_section',
  strict: false,
  fields: {
    title: {
      field: 'title',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-lang_string',
      label: {
        ja: 'セクションタイトル',
        en: 'Section Title'
      }
    },
    icon: {
      field: 'icon',
      type: 'string',
      mandatory: false,
      label: {
        ja: 'セクション用のアイコン',
        en: 'Icon'
      }
    }
  }
}
export const PART_SUB_PAGE_LIST_RULE: ValidationRule = {
  id: 'jps-part_sub_page_list',
  strict: false,
  fields: {}
}
export const PART_TAB_RULE: ValidationRule = {
  id: 'jps-part_tab',
  strict: false,
  fields: {}
}
export const PART_TAB_CONTENT_RULE: ValidationRule = {
  id: 'jps-part_tab_content',
  strict: true,
  fields: {
    title: {
      field: 'title',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-lang_string',
      label: {
        ja: 'タイトル',
        en: 'Title'
      }
    },
    subTitle: {
      field: 'subTitle',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-lang_string',
      label: {
        ja: 'サブタイトル',
        en: 'Sub Title'
      }
    },
    color: {
      field: 'color',
      type: 'string',
      mandatory: false,
      label: {
        ja: 'タブの色',
        en: 'Color'
      }
    },
    width: {
      field: 'width',
      type: 'number',
      mandatory: false,
      numIntOnly: true,
      label: {
        ja: '幅（%）',
        en: 'Width (%)'
      }
    }
  }
}
export const PART_TEXT_RULE: ValidationRule = {
  id: 'jps-part_text',
  strict: false,
  fields: {}
}
export const PART_TIME_POINT_RULE: ValidationRule = {
  id: 'jps-part_time_point',
  strict: true,
  fields: {
    time: {
      field: 'time',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-time',
      label: {
        ja: '時間',
        en: 'Time'
      }
    },
    description: {
      field: 'description',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-lang_string',
      label: {
        ja: '説明',
        en: 'Description'
      }
    }
  }
}
export const PART_TIMELINE_RULE: ValidationRule = {
  id: 'jps-part_timeline',
  strict: false,
  fields: {
    title: {
      field: 'title',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-lang_string',
      label: {
        ja: 'タイトル',
        en: 'Title'
      }
    },
    timeline: {
      field: 'timeline',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-timeline',
      label: {
        ja: '時間軸の設定',
        en: 'Timeline'
      }
    },
    layout: {
      field: 'layout',
      type: 'string',
      mandatory: false,
      enumKey: 'jps-time_line_layout',
      label: {
        ja: 'タイムラインの表示方法',
        en: 'Timeline Layout'
      }
    }
  }
  , enums: {
    'jps-time_line_layout': TIME_LINE_LAYOUT_DEF
  }
}
export const TIME_RULE: ValidationRule = {
  id: 'jps-time',
  strict: true,
  fields: {
    name: {
      field: 'name',
      type: 'object',
      mandatory: false,
      jaMandatory: true,
      objRuleName: 'jps-lang_string',
      label: {
        ja: '文字表現',
        en: 'Description'
      }
    },
    start: {
      field: 'start',
      type: 'number',
      mandatory: true,
      numIntOnly: true,
      label: {
        ja: '開始年',
        en: 'Start Year'
      }
    },
    startFraction: {
      field: 'startFraction',
      type: 'number',
      mandatory: false,
      label: {
        ja: '開始時間',
        en: 'Time Offset'
      },
      description: {
        ja: '年表機能は年単位でしか設定できません。月・日・時間などを表現したい場合は、文字表現に入れていただき、ポイントの位置調整にこの開始時間を使って下さい。開始時間に1より小さい値を入れることで、1年未満の位置の調整が出来ます。例：8月1日は1月1日から数えて213日なので、213÷365=0.583',
        en: 'This timeline supports only year-level settings. To represent months, days, or times, enter them in the Description field and use this offset to position the point within the year. Enter a value smaller than 1. Example: August 1 is the 213th day from January 1, so 213 / 365 = 0.583.'
      }
    },
    end: {
      field: 'end',
      type: 'number',
      mandatory: true,
      numIntOnly: true,
      label: {
        ja: '終了年',
        en: 'End Year'
      }
    },
    endFraction: {
      field: 'endFraction',
      type: 'number',
      mandatory: false,
      label: {
        ja: '終了時間',
        en: 'End Time'
      }
    },
    labelHeight: {
      field: 'labelHeight',
      type: 'number',
      mandatory: false,
      numIntOnly: true,
      label: {
        ja: 'ラベル高さ',
        en: 'Label Height'
      }
    }
  }
}
export const TIMELINE_RULE: ValidationRule = {
  id: 'jps-timeline',
  strict: true,
  fields: {
    start: {
      field: 'start',
      type: 'number',
      mandatory: true,
      numIntOnly: true,
      label: {
        ja: '開始年',
        en: 'Start Year'
      }
    },
    end: {
      field: 'end',
      type: 'number',
      mandatory: true,
      numIntOnly: true,
      label: {
        ja: '終了年',
        en: 'End Year'
      }
    }
  }
}
export const TAG_FIELD_RULE: ValidationRule = {
  id: 'jps-tag_field',
  strict: true,
  fields: {
    id: {
      field: 'id',
      type: 'string',
      mandatory: false
    },
    label: {
      field: 'label',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-lang_string'
    }
  }
}
export const MAP_PARAM_RULE: ValidationRule = {
  id: 'jps-map_param',
  strict: true,
  fields: {
    center: {
      field: 'center',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-lat_lon',
      label: {
        ja: '地図表示の中心',
        en: 'Center for the map'
      }
    },
    zoom: {
      field: 'zoom',
      type: 'number',
      mandatory: false,
      numIntOnly: true,
      label: {
        ja: '地図表示の初期倍率',
        en: 'Initial zoom for the map'
      }
    },
    mode: {
      field: 'mode',
      type: 'string',
      mandatory: false,
      enumKey: 'jps-map_mode',
      label: {
        ja: '地図の表示モード',
        en: 'Map display mode'
      }
    }
  }
  , enums: {
    'jps-map_mode': MAP_MODE_DEF
  }
}
